import { render, staticRenderFns } from "./RiscossioneListModal.vue?vue&type=template&id=75b7ee69&"
import script from "./RiscossioneListModal.vue?vue&type=script&lang=ts&"
export * from "./RiscossioneListModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports